import { loadScript } from '/src/utils';

let INTERCOM_APP_ID = '';

const intercomSettings = {
    custom_launcher_selector: '.intercom_launcher_link',
    alignment: 'right',
    horizontal_padding: 20,
    vertical_padding: 70,
};

const intercomLoad = app_id => {
    INTERCOM_APP_ID = app_id;
    const i = function() { i.c(arguments) };
    i.q = [];
    i.c = function(args) { i.q.push(args) };
    window.Intercom = i;

    setTimeout(() => {
        loadScript('https://widget.intercom.io/widget/b1y3yb28')
            .catch(() => console.log('load intercom error'))
    }, 5000);

    window.Intercom('boot', { ...intercomSettings, app_id: INTERCOM_APP_ID });
};

const intercomLoginUser = ({ email, name }) => {
    window.Intercom('update', { email, name });
};

const intercomLogoutUser = () => {
    window.Intercom('shutdown');
    window.Intercom('boot', { ...intercomSettings, app_id: INTERCOM_APP_ID });
};

export {
    intercomLoad,
    intercomLoginUser,
    intercomLogoutUser,
};
